export enum ObservationLevel {
    // BRAPI Standard accepted levels
    STUDY = 'study',
    FIELD = 'field',
    REP = 'rep',
    BLOCK = 'block',
    PLOT = 'plot',
    SUB_PLOT = 'sub-plot',
    PLANT = 'plant',
    // BMS Implementation additional levels
    TIMESERIES = 'timeseries',
    CUSTOM = 'custom',
    SUMMARY_STATISTICS = 'summary_statistics',
    MEANS = 'means'
}
